var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":_vm.item.to,"active-class":`primary white--text`}},[_c('v-list-item-icon',[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.item.icon)}})],1),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.item.title)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }